import {forwardRef, SVGProps} from 'react';

export const ConversationIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor' {...props} ref={ref}>
        <path d='M15 12V5H4v8.17L5.17 12H15ZM3 3h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6l-4 4V4a1 1 0 0 1 1-1Zm5 14h10.83L20 18.17V9h-1.25V7H21a1 1 0 0 1 1 1v15l-4-4H7a1 1 0 0 1-1-1v-2h2v1Z' />
    </svg>
));
